import React from "react";
import Header from "../../../components/Header/Header";
import "./mapData.scss";
import MapFooter from "../../../components/Footer/MapFooter";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/processor/actions";
import { connect } from "react-redux";
import "react-multi-carousel/lib/styles.css";
import ProgressBar from "../../../components/ProgressBar";
import CustomizedSnackbar from "../../../components/Snackbars/CustomizedSnackbars";
import ModalProcessor from "../../../components/Modal/RejectModal/ModalProcessor";
import DataEntryContainer from "./DataEntryContainer";
import IconButton from "@mui/material/IconButton";
import { StepConnector, Stepper, StepLabel, Step, Grid } from "@mui/material";
import { notification } from "../../../constants/notificationMessages";
import styled from "styled-components";
import HideImageOutlinedIcon from "@mui/icons-material/HideImageOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import TableSkeleton from "../../../components/Skeletons/TableSkeleton";
import Label from "../../../components/Label/Label";
import { proRoutes } from "../../../routes/routeConstants";

const ColorlibConnector = styled(StepConnector)({
  alternativeLabel: {},
  active: {
    "& $line": {
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      fontWeight: 700,
    },
  },
  completed: {
    "& $line": {
      borderColor: "rgba(0,0,0,0.7)",
      borderBottom: "3px solid rgba(0,0,0,0.7)",
      borderTopWidth: "0px!important",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#B9B9B9",
    borderRadius: 1,
    borderTopWidth: "0px!important",
  },
});

class MapData extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coorData: [],
      // isFullView: false,
      leftgrid: 6,
      rightgrid: 6,
      isFullScreen: true,
      hideScreen: true,
      action: "",
      batchRejection: false,
      rejectionRemark: "",
      // projectType:localStorage.getItem("projectType")
      batch_for_qc: localStorage.getItem("batch_for_qc"),
      assignToValidator: false,
    };
    // Create the child instance using react createRef
    this.child = React.createRef();
    this.qcChild = React.createRef();
  }

  componentDidMount() {
    this.props.acts.clearApiStatus();
    this.props.acts.clearDataEntryApiStatus();
    this.props.acts.getProData(localStorage.batchId, localStorage.projectId);

    // Set up the interval
    this.interval = setInterval(() => {
      // if (this.child.current) {
      // Ensure child is mounted before calling
      // this.onClickFooterAction("save", null, true);
      // }
    }, 120000); // 1 minute
  }

  componentWillUnmount() {
    // Clean up the interval
    clearInterval(this.interval);
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   if (
  //     nextProps?.entireBatchRejectedByPro &&
  //     nextProps?.entireBatchRejectedByPro
  //   ) {
  //     this.setState({ batchRejection: nextProps?.entireBatchRejectedByPro });
  //   }
  //   // main page get api call
  //   if (nextProps?.apiStatus?.loader === true) {
  //     this.setState({
  //       loader: true,
  //     });
  //   }

  //   // if (nextProps?.dataEntryApiStatus?.loader === true) {
  //   this.setState({
  //     progressBarLoader: nextProps?.dataEntryApiStatus?.loader,
  //   });
  //   // }

  //   if (
  //     nextProps?.dataEntryApiStatus?.loader === false &&
  //     nextProps?.dataEntryApiStatus?.next === false &&
  //     nextProps?.dataEntryApiStatus?.apiSuccess === true
  //   ) {
  //     this.setState({
  //       sucessNotification: true,
  //       message: notification.successMessage,
  //     });
  //     this.props.acts.clearDataEntryApiStatus();
  //   }
  //   if (
  //     nextProps?.dataEntryApiStatus?.loader === false &&
  //     nextProps?.dataEntryApiStatus?.next === true
  //   ) {
  //     this.setState({
  //       progressBarLoader: false,
  //       sucessNotification: true,
  //       errorNotification: false,
  //       message: notification.successMessage,
  //     });

  //     if (
  //       this.state.action === "saveAndNext" &&
  //       this.state?.batch_for_qc === "false"
  //     ) {
  //       setTimeout(() => {
  //         this.setState({
  //           sucessNotification: false,
  //           message: "",
  //         });
  //         this.props?.navigate("/pro-user-permission");
  //       }, 2000);
  //     }

  //     if (
  //       this.state.action === "saveAndNext" &&
  //       this.state?.batch_for_qc === "true"
  //     ) {
  //       setTimeout(() => {
  //         this.setState({
  //           sucessNotification: false,
  //           message: "",
  //         });
  //         this.props?.navigate("/processor-dashboard");
  //       }, 2000);
  //     }

  //     if (this.state.action === "save") {
  //       setTimeout(() => {
  //         this.setState({
  //           sucessNotification: false,
  //           message: "",
  //           progressBarLoader: false,
  //         });
  //       }, 2000);
  //     }
  //     this.props.acts.clearDataEntryApiStatus();
  //   }
  //   if (
  //     nextProps?.dataEntryApiStatus?.apiError === true &&
  //     nextProps?.dataEntryApiStatus?.loader === false &&
  //     nextProps?.dataEntryApiStatus?.message !== null
  //   ) {
  //     this.setState({
  //       progressBarLoader: false,
  //       sucessNotification: false,
  //       errorNotification: true,
  //       message: nextProps?.dataEntryApiStatus?.message,
  //     });
  //     this.props.acts.clearDataEntryApiStatus();
  //   }
  //   if (
  //     nextProps?.dataEntryApiStatus?.loader === false &&
  //     nextProps?.dataEntryApiStatus?.isRejected === true
  //   ) {
  //     this.setState({
  //       progressBarLoader: false,
  //       sucessNotification: true,
  //       errorNotification: false,
  //       message: notification.successMessage,
  //     });
  //     setTimeout(() => {
  //       this.setState({
  //         sucessNotification: false,
  //         message: "",
  //       });
  //       this.props?.navigate("/processor-dashboard");
  //     }, 2000);
  //     this.props.acts.clearDataEntryApiStatus();
  //   }
  // }

  componentDidUpdate(prevProps) {
    const { entireBatchRejectedByPro, apiStatus, dataEntryApiStatus } =
      this.props;

    // Check for batch rejection update
    if (
      entireBatchRejectedByPro
      // &&
      // entireBatchRejectedByPro !== prevProps.entireBatchRejectedByPro
    ) {
      this.setState({ batchRejection: entireBatchRejectedByPro });
    }

    // Main page loader update
    if (
      apiStatus?.loader === true &&
      prevProps.apiStatus?.loader !== apiStatus.loader
    ) {
      this.setState({ loader: true });
    }

    // Progress bar loader update
    if (dataEntryApiStatus?.loader !== prevProps.dataEntryApiStatus?.loader) {
      this.setState({ progressBarLoader: dataEntryApiStatus.loader });
    }

    // Success notification and navigation handling when dataEntryApiStatus is successful
    if (
      dataEntryApiStatus?.loader === false &&
      dataEntryApiStatus?.next === false &&
      dataEntryApiStatus?.apiSuccess === true &&
      prevProps.dataEntryApiStatus !== dataEntryApiStatus
    ) {
      this.setState({
        sucessNotification: true,
        message: notification.successMessage,
      });
      this.props.acts.clearDataEntryApiStatus();
    }

    // Success handling with next step based on action type and batch QC status
    if (
      dataEntryApiStatus?.loader === false &&
      dataEntryApiStatus?.next === true &&
      prevProps.dataEntryApiStatus !== dataEntryApiStatus
    ) {
      this.setState({
        progressBarLoader: false,
        sucessNotification: true,
        errorNotification: false,
        message: notification.successMessage,
      });

      if (this.state.action === "saveAndNext") {
        let path = "";
        // process.env.REACT_APP_VALIDATOR_FOR_QC === "true" &&
        // this.state.batch_for_qc
        //   ? "/pro-user-permission"
        //   : process.env.REACT_APP_VALIDATOR_FOR_QC === "false" &&
        //     this.state.batch_for_qc === "true"
        //   ? "/processor-dashboard"
        //   : "/pro-user-permission";
        if (this.state.batch_for_qc === "true") {
          path =
            this.state.assignToValidator === true
              ? //       ? "/pro-user-permission"
                //       : "/processor-dashboard";
                // else path = "/pro-user-permission";
                `/${proRoutes.proUserPermission}`
              : `/${proRoutes.proDashboard}`;
        } else
          path =
            dataEntryApiStatus?.isReprocess === true
              ? `/${proRoutes.proDashboard}`
              : `/${proRoutes.proUserPermission}`;

        setTimeout(() => {
          this.setState({
            sucessNotification: false,
            message: "",
          });
          this.props.navigate(path);
        }, 2000);
      } else if (this.state.action === "save") {
        setTimeout(() => {
          this.setState({
            sucessNotification: false,
            message: "",
            progressBarLoader: false,
          });
        }, 2000);
      }
      this.props.acts.clearDataEntryApiStatus();
    }

    // Error notification handling
    if (
      dataEntryApiStatus?.apiError === true &&
      dataEntryApiStatus?.loader === false &&
      dataEntryApiStatus?.message &&
      prevProps.dataEntryApiStatus !== dataEntryApiStatus
    ) {
      this.setState({
        progressBarLoader: false,
        sucessNotification: false,
        errorNotification: true,
        message: dataEntryApiStatus.message,
      });
      this.props.acts.clearDataEntryApiStatus();
    }

    // Handling rejection status
    if (
      dataEntryApiStatus?.loader === false &&
      dataEntryApiStatus?.isRejected === true &&
      prevProps.dataEntryApiStatus !== dataEntryApiStatus
    ) {
      this.setState({
        progressBarLoader: false,
        sucessNotification: true,
        errorNotification: false,
        message: notification.successMessage,
      });
      setTimeout(() => {
        this.setState({
          sucessNotification: false,
          message: "",
        });
        // this.props.navigate("/processor-dashboard");
        this.props.navigate(`/${proRoutes.proDashboard}`);
      }, 2000);
      this.props.acts.clearDataEntryApiStatus();
    }
  }

  onClickFooterAction = (action, e, autoSave = false) => {
    if (action === "cancel") {
      // this.props.navigate("/processor-dashboard");
      this.props.navigate(`/${proRoutes.proDashboard}`);
    } else if (action === "reject") {
      if (!e.target.checked) {
        this.setState({
          batchRejection: false,
          rejectionRemark: "",
        });
      } else if (e.target.checked) {
        this.setState({
          openRejectionModal: true,
        });
      }
    } else {
      this.setState({
        action: action,
      });

      if (this.state?.batch_for_qc === "false" && this.child.current) {
        if (this?.state?.batchRejection) {
          this.child.current.mapData(
            "reject",
            this?.state?.rejectionRemark,
            this?.state?.batchRejection
          ); // if entire batch is rejected
        } else this.child.current.mapData(action, null, null, null, autoSave);
      } else if (this.state?.batch_for_qc === "true" && this.qcChild.current) {
        if (this?.state?.batchRejection) {
          // this.qcChild.current.mapData2(action, autoSave);

          this.qcChild.current.mapData2(
            "reject",
            this?.state?.rejectionRemark,
            this?.state?.batchRejection,

            false // autoSave,
          );

          // if entire batch is rejected
        } else this.qcChild.current.mapData2(action, "", false, autoSave);
      }
    }
  };

  onClickValidatorView = (checked) => {
    this.setState({
      assignToValidator: checked,
    });
  };

  handleCloseModal = () => {
    this.setState({
      openRejectionModal: false,
      batchRejection: false,
    });
  };

  handleReject = (remark) => {
    this.setState({
      openRejectionModal: false,
      batchRejection: true,
      rejectionRemark: remark,
    });
  };

  slideScreentoMaximize = () => {
    this.setState({ rightgrid: 12 });
    this.setState({ isFullScreen: false });
    this.setState({ hideScreen: false });
  };
  slideScreentoMinimize = () => {
    this.setState({ leftgrid: 6 });
    this.setState({ rightgrid: 6 });
    this.setState({ isFullScreen: true });
    this.setState({ hideScreen: true });
  };

  // handleCloseFullView = () => {
  //   this.setState({ isFullView: false });
  // };

  // handleOpenFullView = () => {
  //   this.setState({ isFullView: true });
  // };

  render() {
    return (
      <div>
        <Header />
        <div className="fullscreen-view">
          {this.state.isFullScreen ? (
            <div
            // className="slide-button"
            >
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => this.slideScreentoMaximize()}
              >
                <ImageOutlinedIcon />
              </IconButton>
              {/* <Buttons
                size="small"
                onClick={() => this.slideScreentoMaximize()}
                text="Hide PDF"
                startIcon={<ArrowLeftIcon />}
              /> */}
            </div>
          ) : (
            <div
            // className="slide-button"
            >
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => this.slideScreentoMinimize()}
              >
                <HideImageOutlinedIcon />
              </IconButton>
              {/* <Buttons
                size="small"
                onClick={() => this.slideScreentoMinimize()}
                text="Show PDF"
                startIcon={<ArrowRightIcon />}
              /> */}
            </div>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Label
              color="#4096fc"
              fontWeight="600"
              fontSize="16px"
              text={localStorage.projectName + " - " + localStorage.batchName}
            />
            {/* <Typography className="project-batch-header">
              {localStorage.projectName + " - " + localStorage.batchName}
            </Typography> */}
            {/* <Chip
              style={{ marginLeft: "5px" }}
              label={
                localStorage.batch_for_qc === true ? "Quality Check" : "Auto Extraction"
              }
              // size="small"
              className="extraction-type2"
            /> */}
          </div>

          <Stepper
            activeStep={this.state.activeStep}
            connector={<ColorlibConnector />}
          >
            <Step key="Data Entry" className="stepper-wrap-label">
              <StepLabel>Data Entry</StepLabel>
            </Step>
          </Stepper>

          {/* <IconButton aria-label="fullView">
            <Typography className="current-step"> Data Entry</Typography>
          </IconButton> */}
        </div>
        {/* 
        {this?.state?.isFullView ? (
          <Dialog
            fullScreen={true}
            open={this?.state?.isFullView}
            aria-labelledby="responsive-dialog-title"
            keepMounted={true}
          >
            <DialogActions className="dialog-style">
              {this.state.isFullScreen ? (
                <div className="slide-button">
                  <Buttons
                    size="small"
                    onClick={() => this.slideScreentoMaximize()}
                    text="Hide PDF"
                    startIcon={<ArrowLeftIcon />}
                  />
                </div>
              ) : (
                <div className="slide-button">
                  <Buttons
                    size="small"
                    onClick={() => this.slideScreentoMinimize()}
                    text="Show PDF"
                    startIcon={<ArrowRightIcon />}
                  />
                </div>
              )}
              <IconButton
                className="fullview-close"
                aria-label="close"
                onClick={this.handleCloseFullView}
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>

            <DialogContent className="fullscreen-table-wrap">
              <DataEntryContainer
                child={this.child}
                isFullView={this?.state?.isFullView}
                hideScreen={this?.state?.hideScreen}
                leftgrid={this?.state?.leftgrid}
                rightgrid={this?.state?.rightgrid}
              />
            </DialogContent>
          </Dialog>
        ) : ( */}

        {this.props?.apiStatus?.loader ? (
          // <ProgressBar />
          <Grid container spacing={1}>
            <Grid item sm={6} xs={12}>
              <TableSkeleton />
            </Grid>
            <Grid item sm={6} xs={12}>
              <TableSkeleton />
            </Grid>
          </Grid>
        ) : (
          <DataEntryContainer
            child={this?.child}
            qcChild={this?.qcChild}
            // isFullView={this?.state?.isFullView}
            hideScreen={this?.state?.hideScreen}
            leftgrid={this?.state?.leftgrid}
            rightgrid={this?.state?.rightgrid}
            assignToValidator={this.state.assignToValidator}
            {...this?.props}
          />
        )}
        {/* )} */}

        <MapFooter
          pdfCount={this.props?.coorData.length}
          isDisableMultipageMappingLable={true}
          onClickFooterAction={this.onClickFooterAction}
          batchRejection={this.state.batchRejection}
          role="processor"
          onClickValidatorView={this.onClickValidatorView}
          assignToValidator={this.state.assignToValidator}
          batch_for_qc={this.state.batch_for_qc}
        />

        {this.state.progressBarLoader ? <ProgressBar /> : ""}

        {this.state?.sucessNotification && (
          <CustomizedSnackbar
            severity="success"
            state={this.state?.sucessNotification}
            text={this.state?.message}
            handleClose={() =>
              this.setState({
                sucessNotification: false,
              })
            }
          />
        )}
        {this.state?.errorNotification && (
          <CustomizedSnackbar
            severity="error"
            state={this.state?.errorNotification}
            text={this.state.message}
            handleClose={() =>
              this.setState({
                errorNotification: false,
              })
            }
          />
        )}

        {/* {this.props?.apiStatus?.loader ? <ProgressBar /> : ""} */}

        {this.state.openRejectionModal && (
          <ModalProcessor
            modalOpen={this.state.openRejectionModal}
            handleClose={this.handleCloseModal}
            handleReject={this.handleReject}
            isShowClearButton={false}
            disableDeleteRejection={true}
            isShowDeleteButton={false}
            heading={"Do you want to reject the batch?"}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    coorData: state.pro?.coorData?.coordinatesDetails || [],
    parametersData: state.pro?.coorData?.mapping_details?.parametersData,
    apiStatus: state.pro?.apiStatus,
    entireBatchRejectedByPro:
      state.pro?.coorData?.mapping_details?.entireBatchRejectedByPro,
    dataEntryApiStatus: state.pro?.dataEntryApiStatus,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MapData);
